import { apiDelete, apiGet, apiPost } from '@/services/api/http'

export interface PushSubscriptionKeys {
  p256dh: string
  auth: string
}

export interface PushSubscribeInput {
  endpoint: string
  keys: PushSubscriptionKeys
  userAgent?: string
}

export const pushService = {
  getPublicKey: (): Promise<{ publicKey: string | null }> =>
    apiGet<{ publicKey: string | null }>('/notifications/push-public-key'),

  subscribe: (input: PushSubscribeInput): Promise<{ subscribed: boolean }> =>
    apiPost<{ subscribed: boolean }>('/notifications/push-subscribe', input),

  unsubscribe: (endpoint: string): Promise<{ unsubscribed: boolean }> =>
    apiDelete<{ unsubscribed: boolean }>('/notifications/push-subscribe', { data: { endpoint } }),
}
